export const logError = (value: string) => {
  // TODO: add sentry loging
  console.error(value);
};
